module.exports = __webpack_public_path__ + "media/images/arrow-l-c964b4fe2134afe97996470a6bed2be6.png";